import React from 'react';
import { connect } from 'react-redux';
import { saveSubscription } from '../actions/subscriptionActions';
import { withTranslation } from "react-i18next";

import ARPrimaryButton from '../react/shared/components/general/ARButtons/ARPrimaryButton';

class SaveButton extends React.Component {
  
  handleSaveSubscription = () => {
    var { recipient, isOptOut } = this.props;
    this.props.saveSubscription(recipient,isOptOut);
  }
  
  render() {
    var { t, isOptOut,isOptOutOriginal,isSaving } = this.props;
    var buttonProps = {
      className: "saveButton",
      size: "large"
    };
    if(isOptOut === isOptOutOriginal) {
      buttonProps.disabled = true;
    }

    if(isSaving) {
      buttonProps.disabled = true;
      buttonProps.loading = true;
    } else {
      buttonProps.onClick = this.handleSaveSubscription;
    }
    
    return (
      <ARPrimaryButton 
        {...buttonProps}
      >
        {t('save')}
      </ARPrimaryButton>
    );
  }
}

const mapStateToProps = state => ({
  recipient: state.recipient,
  isOptOut: state.status.selected,
  isOptOutOriginal: state.status.saved,
  isSaving: state.status.isSaving
});
export default connect(mapStateToProps,{ saveSubscription })(withTranslation()(SaveButton));